import { useCallback, useState } from "react";

export const useVisibility = (initialValue = false) => {
  const [isVisible, setIsVisible] = useState(initialValue);
  return [isVisible, useCallback((value: boolean) => () => setIsVisible(value), [])] as const;
};
